<template>
    <div class="row">
        <Main class="col-md-8 pr-0"></Main>
        <Side class="col-md-4 pr-0"></Side>
    </div>
</template>
<script type="text/javascript">
    import Main from '@/components/main_page/sub_components/dashboard_main.vue'
    import Side from '@/components/main_page/sub_components/dashboard_side.vue'

    import {mapActions} from 'vuex'

    export default {
        components: {
            Main,
            Side,
        },
        methods: {
            ...mapActions({
                get_dashboard_apps_content: 'main/get_dashboard_apps_content',
                change_index_content: 'main/change_index_content',
            })
        },
        mounted: function () {
            this.get_dashboard_apps_content()
        }
    }

</script>
<style type="text/css" scoped>

</style>
